<div>
  <div class="grid">
    <div class="col-12">
      <div class="p-fluid">
        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="formgroup-inline">
              <button pButton
                      *ngIf="statutOuvrage !== '2' && userService.canEdit()"
                      [disabled]="(degradedModeService.isDegradedMode() | async) ?? false"
                      pRipple
                      type="button"
                      icon="pi pi-plus"
                      class="p-button-success humensis-green"
                      (click)="insertRow()"></button>

              <div class="field">
                <p-inputNumber mode="decimal"
                               [style]="{'width':'50px'}"
                               class="inputNumber-width"
                               *ngIf="statutOuvrage !== '2' && userService.canEdit()"
                               [showButtons]="false"
                               [min]="0"
                               [(ngModel)]="rowToAddNumber"
                               [max]="500">
                </p-inputNumber>
              </div>

              <button pButton
                      pRipple
                      type="button"
                      icon="pi pi-filter"
                      title="Sauvegarder les filtres pour cet ouvrage"
                      class="p-button-success humensis-green"
                      *ngIf="!this.hasSavedFilter"
                      (click)="saveFilter()"></button>
              <button pButton
                      pRipple
                      style="margin-left:5px"
                      icon="pi pi-filter"
                      type="button"
                      title="Supprimer les filtres enregistrés pour cet ouvrage"
                      class="p-button-success humensis-red"
                      *ngIf="this.hasSavedFilter"
                      (click)="deleteFilter()"></button>
              <button pButton
                      pRipple
                      style="margin-left:5px"
                      icon="pi pi-question"
                      type="button"
                      title="Restrictions appliquées à cet ouvrage"
                      class="p-button-success humensis-green"
                      *ngIf="isRestrictionActive()"
                      (click)="displayHelpRestriction = true"></button>
            </div>

            <div>
            </div>
          </div>
        </div>

        <div style="overflow-x:hidden;height:auto">
          <div [hidden]="!(ressources && ressources.length>0)">
            <app-handsontable
              [id]="idTable"
              style="overflow: hidden;"
              [dataset]="ressources"
              [settings]="settings"
              [columns]="columns"
              [customCellProps]="customCellProps"
              [resetDataset]="resetDataset"
              (onDataChange)="saveChanges($event)"
              (onCreateRow)="createRessourceNumerique($event)"
            >
            </app-handsontable>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<p-dialog (onHide)="setTextCell()"
          [modal] = "true"
          [(visible)]="display">
  <p-editor [(ngModel)]="text"
            [style]="{'height':'320px', 'width': '500px'}">

    <ng-template pTemplate="header">
        <span class="ql-formats">
            <select class="ql-size">
              <option value="small"></option>
              <!-- Note a missing, thus falsy value, is used to reset to default -->
              <option selected></option>
              <option value="large"></option>
              <option value="huge"></option>
            </select>
            <button type="button"
                    class="ql-bold"
                    aria-label="Bold"></button>
            <button type="button"
                    class="ql-italic"
                    aria-label="Italic"></button>
            <button type="button"
                    class="ql-underline"
                    aria-label="Underline"></button>
  <button class="ql-script"
          value="sub"></button>
  <button class="ql-script"
          value="super"></button>
        </span>
    </ng-template>

  </p-editor>
</p-dialog>

<p-dialog
  [style]="{width: '50vw'}"
  [modal] = "true"
  (onHide)="setCategorie()"
  (click)="autoClose('categorie')"
  [(visible)]="displayCategories">
  <div class="grid">
    <div class="col-12 md:col-4"
         *ngFor="let categorie of categories">
      <div class="field-radiobutton">
        <p-radioButton name="categorie"
                       label="{{categorie.key}}"
                       value="{{categorie.value}}"
                       [(ngModel)]="selectedCategorie"
                       [id]="categorie.value"></p-radioButton>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  [style]="{width: '50vw'}"
  [modal]="true"
  [dismissableMask]="true"
  (click)="autoClose('format')"
  (onHide)="setFormat()"
  [(visible)]="displayFormats">
  <div class="grid">
    <div class="col-12 md:col-4"
         *ngFor="let format of formats">
      <div class="field-radiobutton">
        <p-radioButton name="format"
                       label="{{format.key}}"
                       value="{{format.value}}"
                       [(ngModel)]="selectedFormat"
                       [id]="format.value"></p-radioButton>
      </div>
    </div>
  </div>
</p-dialog>

  <p-dialog
  [modal] = "true"
  [style]="{width: 'auto', height: 'auto', overflow: 'visible'}"
  (onHide)="setPage()"
  [(visible)]="displayPages">
  <div
    style="overflow-y:visible"
       *ngIf="pages.length > 0">
    <p-multiSelect
      [options]="pages"
      [filter]="true"
      optionLabel="pageId"
      optionValue="pageId"
      [(ngModel)]="selectedPage">
    </p-multiSelect>
  </div>
</p-dialog>

<p-dialog
  [modal] = "true"
  [style]="{width: '25vw'}"
  (onHide)="setCible()"
  (click)="autoClose('cible')"
  [(visible)]="displayCible">
  <div class="grid">
    <div class="col-12 md:col-4"
         *ngFor="let cible of cibles">
      <div class="field-radiobutton">
        <p-radioButton name="cible"
                       label="{{cible.key}}"
                       value="{{cible.value}}"
                       [(ngModel)]="selectedCible"
                       [id]="cible.value"></p-radioButton>
      </div>
    </div>
  </div>
</p-dialog>


<div>
  <div *ngFor="let ressource of ressources">

    <!-- Modal -->
    <div>
      <dialog class="dialog"
              id="fileUploadDialog_{{ressource.id}}"
              #dialogs>
        <p-fileUpload name="demo"
                      [multiple]=false
                      [fileLimit]=1
                      [customUpload]="true"
                      (uploadHandler)="onBasicUpload($event, ressource.id)">

          <ng-template pTemplate="content">
            <ul *ngIf="uploadedFiles.length">
              <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
            </ul>
          </ng-template>
        </p-fileUpload>

        <ul *ngFor="let media of ressource.medias">
          <li>{{media.filename}}
            <button pButton
                    (click)="deleteAsset(ressource.id, media.id)"
                    pRipple
                    type="button"
                    icon="pi pi-times"
                    class="p-button-rounded p-button-danger mr-2 mb-2"></button>
          </li>
        </ul>

        <div class="loading mb-2 mt-2" *ngIf="this.loadingUpload" >
          <p class="mb-2 mt-2">
            Upload du fichier en cours ...
          </p>
          <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
        </div>

        <button pButton
                pRipple
                label="Fermer"
                icon="pi pi-times"
                class="close_dialog"
                (click)="closeDialog($event)"></button>
      </dialog>
    </div>

  </div>
</div>

<p-dialog
  header="Restrictions appliquées à cet ouvrage"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{width: '30vw'}"
  [(visible)]="displayHelpRestriction">
  <p>
    À partir du {{ dateDebutRestriction | date: 'dd/MM/yyyy' }},  la règle suivante s’applique :
  </p>
  <ul>
    <li>
      Colonne « N° folio » : le numéro doit comporter 3 ou 4 chiffres.
    </li>
    <li>
      Colonne « Structure » : 6 caractères, un « t » minuscule, 2 chiffres,
      un « c » minuscule, 2 chiffres (exemple : t01c02).
    </li>
  </ul>
</p-dialog>

<p-dialog
  header="Sauvegarde impossible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{width: '30vw'}"
  [(visible)]="displayValidationError">
  <p>
    La sauvegarde a été annulée car les colonnes « Structure » et/ou
    « N° folio » ne respectent pas le format attendu sur les lignes
    suivantes (cellules en rouge dans le tableau) :
  </p>
  <ul>
    <li *ngFor="let error of validationErrorRows">
      Ligne {{error.ligne}} :
      <span *ngIf="error.structureInvalid">Structure</span>
      <span *ngIf="error.structureInvalid && error.folioInvalid"> et </span>
      <span *ngIf="error.folioInvalid">N° folio</span>
    </li>
  </ul>
</p-dialog>

<p-toast key="rn_update"></p-toast>
